<template>
  <section id="modal_login" class="modal fade" tabindex="-1" role="dialog">
    <div class="login-panel panel panel-success">
      <div class="panel-heading">
        <h3 class="panel-title">Dados Abertos - Admin</h3>
      </div>
      <div class="panel-body">
        <form role="form" @submit.prevent="login()">
          <fieldset>
            <!-- input para SSHD -->
            <div class="form-group">
              <input
                :class="[
                  'form-control',
                  { 'is-danger': errors.has('username') }
                ]"
                v-model="model.username"
                v-validate="'required'"
                ref="username"
                name="username"
                type="text"
                placeholder="Usuário"
                disabled
              />
              <span v-show="errors.has('username')" class="is-danger">
                <i class="fa fa-warning"></i>
                O campo usuário é obrigatório
              </span>
            </div>
            <div class="form-group">
              <input
                :class="[
                  'form-control',
                  { 'is-danger': errors.has('password') }
                ]"
                v-model="model.password"
                v-validate="'required'"
                ref="password"
                placeholder="Senha"
                name="password"
                type="password"
              />
              <span v-show="errors.has('password')" class="is-danger">
                <i class="fa fa-warning"></i>
                O campo senha é obrigatório
              </span>
            </div>
            <div class="checkbox">
              <label>
                <input
                  type="checkbox"
                  name="usuarioExterno"
                  ref="usuarioExterno"
                  v-model="model.usuarioExterno"
                />Usuário externo
              </label>
            </div>
            <router-link :to="'/login'">
              <span class="alterar-usuario" @click="hide()">Alterar Usuário</span>
            </router-link>
            <!-- Change this to a button or input when using this as a form -->
            <button
              class="btn btn-default btn-block botao-acessar"
              style="margin-bottom:10px"
              type="submit"
              :disabled="requestPendente"
            >
              Acessar
            </button>
          </fieldset>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LoginModal',
  data() {
    return {
      model: {
        username: '',
        password: '',
        usuarioExterno: false
      },
      refresh: false,
      requestPendente: false,
      usernameNoEdit: ""
    }
  },
  mounted() {
    var params = this.$route.params
    if (params.errorMsg) {
      this.$toastr.e(params.errorMsg)
    }
  },
  computed: {
    control() {
      return window.jQuery('#modal_login')
    },
    payload () {
      const { usernameNoEdit: username } = this
      const { password } = this.model

      return { username, password }
    }
  },
  methods: {
    login() {
      this.$validator.validateAll().then(result => {
        this.requestPendente = true
        if (!result) {
          this.requestPendente = false
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e('Verifique os campos obrigatórios')
          return
        }
        this.$store.dispatch('tryLogin', this.payload)
        .then(response => {
          this.requestPendente = false
          this.$toastr.s('Login efetuado com sucesso.')
          this.hide()
          if (this.refresh) {
            this.$router.go(0)
          }
        })
        .catch(({ data }) => {
          this.requestPendente = false
          this.errorMsg = Array.isArray(data) ? data[0] : data
          this.model.password = ''
          this.$toastr.e(this.errorMsg)
          this.$refs.password.focus()
        })
      })
    },
    show(refresh = false) {
      this.model.username = this.$store.state.user.username
      this.usernameNoEdit = this.model.username
      this.control.modal('show')
      this.refresh = refresh
    },
    hide() {
      this.control.modal('hide')
    },
    esconder() {
      router.app.$refs.loginModal.hide()
    }
  }
}
</script>

<style scoped>
section {
  margin: 0 auto;
  max-width: 358px;
  overflow: hidden !important;
}
.botao-acessar {
  margin-top: 12px;
}
.alterar-usuario {
  color: #468c36;
}
.alterar-usuario:hover {
  color: #002220;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/LoginModal.vue